import React from "react";

import { Input, Text, InputPassword } from "react_reusable_components";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { ThreeRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";

export const customInputStyle = {
  iconStyle: { fontSize: variables.fontSizeXlarge },
  errorStyle: {
    marginTop: variables.marginSmall,
    lineHeight: variables.lineHeightSmall,
    fontSize: variables.fontSizeSmall,
    position: "absolute",
  },
  labelStyle: {
    color: variables.textDefault,
    marginBottom: variables.marginSmall,
    lineHeight: variables.lineHeightSmall,
    fontSize: variables.fontSizeNormal,
  },
  inputStyle: (size) => ({
    padding:
      size === "small"
        ? `${variables.paddingSmall3} ${variables.paddingSmall}`
        : variables.paddingSmedium,
    fontSize: variables.fontSizeNormal,
    zIndex: 0,
    ...(size === "small" && { height: variables.mediumHeight }),
  }),
  requiredStyle: {
    color: variables.primaryBg,
  },
};

export default function CustomInput({
  style,
  value,
  onChange,
  className,
  placeholder,
  label,
  labelProps,
  isPassword,
  required,
  error,
  size,
  autoComplete,
  ...props
}) {
  let Component = Input;
  if (isPassword) {
    Component = InputPassword;
  }

  return (
    <ThreeRow
      topSection={
        label && (
          <Text style={customInputStyle.labelStyle}>
            {label}
            {required && (
              <Text style={customInputStyle.requiredStyle}>&nbsp;*</Text>
            )}
          </Text>
        )
      }
      middleSection={
        <Component
          value={value}
          style={{ ...customInputStyle.inputStyle(size), ...style }}
          onChange={onChange}
          placeholder={placeholder}
          {...(isPassword
            ? {
                iconRender: (visible) =>
                  visible ? (
                    <EyeOutlined style={customInputStyle.iconStyle} />
                  ) : (
                    <EyeInvisibleOutlined style={customInputStyle.iconStyle} />
                  ),
              }
            : {})}
          className={className}
          autoComplete={autoComplete || "off"}
          {...props}
        />
      }
      bottomSection={
        !!error && (
          <Text style={customInputStyle.errorStyle} type="danger">
            {error}
          </Text>
        )
      }
    />
  );
}
